import { DeleteKanbanStatusCommandV1, UpdateKanbanStatusesCommandV1 } from '@Alternatives/AlternativesLists/Domain/commands-core';
import AlternativesListsCommands from '@Alternatives/AlternativesLists/Domain/commands-vue-component';
import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
import { AlternativesListReadModel, StatusDependenciesReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
import { ICommandBase } from '@Alternatives/cqrs';
import { AlternativeStatusDTO } from '@Alternatives/Model';
import { AlternativeStatusReadModel } from '@Alternatives/Statuses/Domain/readmodels';
import { Refresh } from '@browser/Browser';
import { generateName, isNullOrWhitespace, numCompare } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { DependentEntityInfo, ValidationError } from '@common/types';
import { ICommandStatus } from '@cqrs/cqrs';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioOrDecisionNavigation
    }
})
export default class ManageKanbanStatusesPage extends mixins(AlternativesListsQueries, AlternativesListsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

    url_ReportViewPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Reports_ReportViewPage(this.$route, e.WorkspaceId, e.TchProjectId, e.Id);
    } 


    rm: AlternativesListReadModel = null;
    depViewer: StatusDependenciesViewerViewModel = new StatusDependenciesViewerViewModel();
    statusDeleter: StatusDeleterViewModel = new StatusDeleterViewModel();
    errors: ValidationError[] = null;

    get AlternativeStatusesView(): AlternativeStatusReadModel[] { return this.rm.Statuses.sort((a, b) => numCompare(a.OrderValue, b.OrderValue)); }
    get EmptyNameExist(): boolean { return this.rm.Statuses.some(a => isNullOrWhitespace(a.Name)); }
    get SaveBtnEnable(): boolean { return this.EmptyNameExist === false && this.rm.Statuses.length > 0; }
    get First(): AlternativeStatusReadModel { return this.AlternativeStatusesView[0]; }
    get Last(): AlternativeStatusReadModel { return this.AlternativeStatusesView[this.AlternativeStatusesView.length - 1]; }


    createStatus()
    {
        const status: AlternativeStatusReadModel = new AlternativeStatusReadModel();
        status.Id = 0;
        status.Name = generateName("Status");
        status.OrderValue = this.Last.OrderValue + 1;
        this.rm.Statuses.push(status);
    }

    deleteStatus(s: AlternativeStatusReadModel)
    {
        if (s.Id == 0)
        {
            this.rm.Statuses.remove(s);
        }
        else
        {
            this.statusDeleter.opened = true;
            this.runStatusDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.Id, s.Id)
        }
    }

    moveUp(s: AlternativeStatusReadModel)
    {
        if (s.Id === this.First.Id) return;

        const thisIndex = this.AlternativeStatusesView.indexOf(s);
        const prevStatusVM = this.AlternativeStatusesView[thisIndex - 1];

        if (prevStatusVM != null)
        {
            prevStatusVM.OrderValue = s.OrderValue;
            s.OrderValue--;
        }
    }

    moveDown(s: AlternativeStatusReadModel)
    {
        if (s.Id === this.Last.Id) return;

        const thisIndex = this.AlternativeStatusesView.indexOf(s);
        const nextStatusVM = this.AlternativeStatusesView[thisIndex + 1];

        if (nextStatusVM != null)
        {
            nextStatusVM.OrderValue = s.OrderValue;
            s.OrderValue++;
        }
    }

    showStatusDependenciesViewer(statusId: number)
    {
        if (statusId > 0)
        {
            if (this.statusDeleter.opened === true)
            {
                this.statusDeleter.opened = false;
            }
            else
            {
                this.runStatusDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.Id, statusId);
            }

            this.depViewer.opened = true;
        }
    }




    handleUpdateKanbanStatusesCommand()
    {
        const statuses: AlternativeStatusDTO[] = this.rm.Statuses.map(s =>
        {
            return {
                Id: s.Id,
                Name: s.Name,
                OrderValue: s.OrderValue
            };
        });
        this.invokeUpdateKanbanStatusesCommandV1(this.workspaceId, this.rm.Id, statuses);
    }

    handleDeleteKanbanStatusCommand()
    {
        this.invokeDeleteKanbanStatusCommandV1(this.workspaceId, this.projectId, this.rm.Id, this.statusDeleter.rm.Id);
    }



    mounted()
    {
        document.title = "Kanban statuses | TransparentChoice";
        this.runAlternativesListByProjectIdQueryV1(this.workspaceId, this.projectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "AlternativesListReadModel")
        {
            this.rm = model as AlternativesListReadModel;
        }
        else if (modelName == "StatusDependenciesReadModel")
        {
            const rm = model as StatusDependenciesReadModel;
            this.depViewer.rm = rm;
            this.statusDeleter.rm = rm;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        this.errors = null;

        if (UpdateKanbanStatusesCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (DeleteKanbanStatusCommandV1.matchType(cmd))
        {
            this.statusDeleter.close();
            this.rm.Statuses = this.rm.Statuses.filter(a => a.Id !== Number(correlationId));
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (UpdateKanbanStatusesCommandV1.matchType(status.Command))
        {
            this.errors = status.ValidationErrors;
        }
    }
}

class StatusDependenciesViewerViewModel
{
    opened: boolean = false;
    rm: StatusDependenciesReadModel = null;

    close()
    {
        this.opened = false;
        this.rm = null;
    }
}

class StatusDeleterViewModel
{
    opened: boolean = false;
    rm: StatusDependenciesReadModel = null;

    close()
    {
        this.opened = false;
        this.rm = null;
    }
}